export default __webpack_public_path__ + "static/media/fl-icon-32.d8eb6304.svg";